"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PANEL = exports.ACCORDION = exports.TITLE = exports.TITLE_WRAPPER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    TITLE_WRAPPER = (0, _cxs["default"])({
  display: "flex",
  justifyContent: "space-between",
  padding: "20px 0px",
  cursor: "pointer"
});

exports.TITLE_WRAPPER = TITLE_WRAPPER;
var TITLE = (0, _cxs["default"])({
  color: _vars.COLOURS.mono.white,
  fontSize: _vars.FONT_SIZES["default"],
  margin: 0
});
exports.TITLE = TITLE;
var ACCORDION = (0, _cxs["default"])({
  width: "100%",
  border: "none",
  textAlign: "left",
  outline: "none",
  fontSize: _vars.FONT_SIZES["default"]
});
exports.ACCORDION = ACCORDION;

var PANEL = function PANEL(a) {
  return (0, _cxs["default"])({
    maxHeight: a,
    overflow: "hidden",
    transition: "max-height 0.3s ease-out"
  });
};

exports.PANEL = PANEL;